<template>
    <div class="about-certificate" v-if="pageSetup != null" id="certificate">
        <div class="container">
            <div class="section-title-new">
                <h3>{{ pageSetup.about_certificates.section_title }}</h3>
            </div>
            <div class="certificate-carousel">
                <swiper :options="swiperOption" ref="certificateCarousel">
                    <swiper-slide v-for="(slide, index) in pageSetup.about_certificates.images" :key="index">
                        <div class="promo-pic">
                            <a :href="slide.pdf_file" download target="_blank">
                                <img :src="slide.img" alt="">
                            </a>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls cert-controls">
                    <div class="container">
                        <div class="cert-btn-prev slider-btn">
                            <svgIcon name="left-arrow" class="icon-left-arrow"/>
                        </div>
                        <div class="swiper-pagination cert-pagination"></div>
                        <div class="cert-btn-next slider-btn">
                            <svgIcon name="right-arrow" class="icon-right-arrow"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'about-certificate-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    slidesPerView: 4,
                    spaceBetween: 23,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3000,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.cert-btn-next',
                        prevEl: '.cert-btn-prev',
                    },
                    pagination: {
                        el: '.cert-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 900px
                        900: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-certificate.scss';
    @import '@/styles/components/about-page/respond/about-certificate-respond.scss';
</style>